<template>
  <div
    :class="
      $vuetify.breakpoint.xsOnly
        ? 'px-2 py-4 animate__animated animate__fadeIn'
        : 'pa-4 animate__animated animate__fadeIn'
    "
  >
    <h2 class="title_tab mb-3">
      {{ x_tablet ? "ช่องทางสั่งซื้อ" : "ช่องทางสั่งซื้อ/บริการหลังการขาย" }}
      <v-btn
        class="float-right"
        :color="mode ? '#cb1a1a' : '#515148'"
        @click="canCel()"
        small
        outlined
      >
        {{ mode ? "ยกเลิก" : "แก้ไข" }}
        <v-icon x-small v-if="!mode" class="ml-1">fas fa-pencil-alt</v-icon>
      </v-btn>
    </h2>

    <div :class="$vuetify.breakpoint.xsOnly ? 'pt-0' : 'pt-2'">
      <v-form ref="form" @submit.prevent="putContact">
        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar color="grey" class="mx-2 mr-6">
                  <v-icon color="white">mdi-phone</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title">
                    โทรศัพท์
                    <span v-if="mode" class="pl-1" style="color: red">*</span>
                  </v-list-item-title>

                  <p v-show="!mode" class="contact-sub-title">
                    {{ contact.phone }}
                  </p>
                  <v-text-field
                    v-show="mode"
                    :rules="rule_tel"
                    dense
                    label="โทรศัพท์"
                    single-line
                    v-model="contact.phone"
                    v-mask="'###-###-####'"
                  ></v-text-field>
                  <!-- <i
                    v-show="mode"
                    class="font-weight-light"
                    style="font-size:12px;color:gray;"
                  >* หากมีมากกว่า 1 หมายเลข ให้คั่นด้วยคอมม่า (,) โดยไม่ต้องเว้นวรรค</i>-->
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <!-- :max-height="mode?'110px':''" :min-height="mode?'110px':''" -->
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar color="grey" class="mx-2 mr-6">
                  <v-icon color="white">mdi-email</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title">
                    email
                    <span v-if="mode" class="pl-1" style="color: red">*</span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                    >{{ contact.email }}</v-list-item-subtitle
                  >
                  <v-text-field
                    v-show="mode"
                    dense
                    label="email"
                    single-line
                    :rules="rule_email"
                    v-model="contact.email"
                  ></v-text-field>
                  <!-- <i v-show="mode" class="font-weight-light" style="font-size:12px;color:#f4f4f4;">*</i> -->
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar class="mx-2 mr-6">
                  <!-- <v-icon color="white" size="30">fab fa-line</v-icon> -->

                  <v-img src="../assets/image/icon-line4.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title"
                    >Line ID</v-list-item-title
                  >
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                    >{{
                      contact.line_id == "" ? "-" : contact.line_id
                    }}</v-list-item-subtitle
                  >
                  <v-text-field
                    :rules="rule_staff_position"
                    v-show="mode"
                    dense
                    label="Line ID"
                    single-line
                    v-model="contact.line_id"
                  ></v-text-field>

                  <v-list-item-title class="contact-title"
                    >URL Line</v-list-item-title
                  >
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                  >
                    <a
                      :style="
                        contact.line_link == ''
                          ? ''
                          : 'text-decoration: underline'
                      "
                      @click="
                        contact.line_link == ''
                          ? ''
                          : clicklink(contact.line_link)
                      "
                      >{{
                        contact.line_link == "" ? "-" : contact.line_link
                      }}</a
                    >
                  </v-list-item-subtitle>
                  <v-text-field
                    :rules="rule_location_link"
                    v-show="mode"
                    dense
                    label="Line Link"
                    single-line
                    v-model="contact.line_link"
                  ></v-text-field>
                  <!-- <i
                    v-show="mode&&line_show"
                    class="font-weight-light"
                    style="font-size:12px;color:gray;"
                  >*ลิงก์ข้างต้นเป็นเพียงค่าตั้งต้นที่รองรับเฉพาะ Line ID เท่านั้น</i>-->
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar color="grey" class="mx-2 mr-6">
                  <v-icon color="white">fab fa-facebook-f</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title"
                    >Facebook</v-list-item-title
                  >
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                    >{{
                      contact.facebook == "" ? "-" : contact.facebook
                    }}</v-list-item-subtitle
                  >
                  <v-text-field
                    :rules="rule_staff_position"
                    v-show="mode"
                    dense
                    label="Facebook"
                    single-line
                    v-model="contact.facebook"
                  ></v-text-field>

                  <v-list-item-title class="contact-title"
                    >URL Facebook</v-list-item-title
                  >
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                  >
                    <a
                      :style="
                        contact.line_link == ''
                          ? ''
                          : 'text-decoration: underline'
                      "
                      @click="
                        contact.facebook_link == ''
                          ? ''
                          : clicklink(contact.facebook_link)
                      "
                      >{{
                        contact.facebook_link == ""
                          ? "-"
                          : contact.facebook_link
                      }}</a
                    >
                  </v-list-item-subtitle>
                  <v-text-field
                    :rules="rule_location_link"
                    v-show="mode"
                    dense
                    label="Facebook Link"
                    single-line
                    v-model="contact.facebook_link"
                  ></v-text-field>
                  <!-- <i
                    v-show="mode&&line_show"
                    class="font-weight-light"
                    style="font-size:12px;color:#f4f4f4;"
                  >*</i>-->
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar color="grey" class="mx-2 mr-6">
                  <v-icon color="white">mdi-map-marker</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title">
                    ที่อยู่
                    <span v-if="mode" class="pl-1" style="color: red">*</span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="!$vuetify.breakpoint.xsOnly"
                    class="contact-sub-title"
                    v-show="!mode"
                  >
                    {{ contact.address }}
                  </v-list-item-subtitle>
                  <p
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="contact-sub-title"
                    v-show="!mode"
                  >
                    {{ contact.address }}
                  </p>
                  <v-text-field
                    :rules="rule_empty_longtext"
                    v-show="mode"
                    dense
                    label="ที่อยู่"
                    single-line
                    v-model="contact.address"
                  ></v-text-field>
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            :class="
              $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
                ? 'py-1 mt-1'
                : ''
            "
          >
            <v-card color="card_body">
              <v-card-title :class="mode ? 'py-0' : 'py-1'">
                <v-list-item-avatar color="grey" class="mx-2 mr-6">
                  <v-icon color="white">mdi-phone-settings</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="contact-title">
                    เบอร์ติดต่อหลังการขาย
                    <span v-if="mode" class="pl-1" style="color: red">*</span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-show="!mode"
                    class="contact-sub-title"
                    >{{ contact.after_sales_contact }}</v-list-item-subtitle
                  >
                  <v-text-field
                    v-show="mode"
                    dense
                    label="เบอร์ติดต่อหลังการขาย"
                    single-line
                    :rules="rule_tel"
                    v-mask="'###-###-####'"
                    v-model="contact.after_sales_contact"
                  ></v-text-field>
                </v-list-item-content>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          v-show="mode"
          color="button"
          dark
          :class="
            $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly
              ? 'float-right my-4'
              : 'float-right mt-8'
          "
          type="submit"
          :loading="btn_loading"
          small
          >บันทึก</v-btn
        >
      </v-form>
    </div>
  </div>
</template>
<script>
// import { mask } from "vue-the-mask";
import { rules } from "../assets/js/validate";
export default {
  // directives: {
  //   mask,
  // },
  components: {},
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      mode: false,
      // mask
      // mobile_mask: "###-###-####",
      rule_tel: rules.tel_rules,
      rule_email: rules.email_rules,
      rule_empty: rules.empty,
      // rule_empty_tel: [
      //   (v) => !!v || "กรุณากรอกข้อมูล",
      //   (v) =>
      //     /^[-,0-9]+$/.test(v) || "กรุณากรอกเฉพาะตัวเลข คอมม่า(,) และขีด(-)",
      //   // v => ((!!v) ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      //   (v) =>
      //     (!!v || v ? v.length <= 50 : false) ||
      //     "ข้อความต้องมีความยาวไม่เกิน 50 ตัวอักษร",
      //   (v) =>
      //     !/ /.test(v) ||
      //     "หากมีมากกว่า 1 หมายเลข ให้คั่นด้วยคอมม่า (,) โดยไม่ต้องเว้นวรรค",
      // ],
      rule_empty_longtext: rules.empty_longtext,
      rule_empty_link: rules.empty_link,
      rule_staff_position: rules.staff_position_rules,
      rule_location_link: rules.location_link_rules,

      // data
      profile: {},
      btn_loading: false,
      // phone: "",
      // email: "",
      // line_id: "",
      // line_link: "",
      // facebook: "",
      // facebook_link: "",
      // address: "",
      contact: {
        phone: "",
        email: "",
        line_id: "",
        line_link: "",
        facebook: "",
        facebook_link: "",
        address: "",
        update_by: "",
        after_sales_contact: "",
      },
      // line_show: false,
    };
  },

  mounted() {},
  created() {
    this.getData();
  },
  // watch: {
  //   "contact.line_id"(val) {
  //     // console.log(val);
  //     if (this.contact.line_link == "") {
  //       setTimeout(() => {
  //         this.contact.line_link = "http://line.me/ti/p/~" + val;
  //       }, 3000);
  //       this.line_show = true;
  //     }
  //   },
  // },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 360) {
        return true;
      } else {
        return false;
      }
    },
    x_tablet() {
      if (this.$vuetify.breakpoint.width < 465) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getData() {
      let contact = {};
      this.all_contact_data = {};
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/complain", this.header_token)
        .then((response) => {
          // console.log(response);
          contact = response.data.result;
          if (response.data.result && response.data.status == "OK") {
            // this.all_contact_data = contact;
            this.contact = {
              phone: contact.phone,
              email: contact.email,
              line_id: contact.line_id == null ? "" : contact.line_id,
              line_link: contact.line_link == null ? "" : contact.line_link,
              facebook: contact.facebook == null ? "" : contact.facebook,
              facebook_link:
                contact.facebook_link == null ? "" : contact.facebook_link,
              address: contact.address,
              after_sales_contact:
                contact.after_sales_contact == null
                  ? ""
                  : contact.after_sales_contact,
              update_by: "",
            };
            // this.phone = contact.phone;
            // this.email = contact.email;
            // this.line_id = contact.line_id;
            // this.line_link = contact.line_link;
            // this.facebook = contact.facebook;
            // this.facebook_link = contact.facebook_link;
            // this.address = contact.address;
          }
        });
    },
    canCel() {
      this.getData();
      this.mode = !this.mode;
    },
    clicklink(link) {
      window.open(link);
      // console.log("clickkkkkkkkkkkkk");
    },
    putContact() {
      this.profile = this.$session.get("profile");
      if (this.$refs.form.validate()) {
        this.btn_loading = true;

        this.contact.line_id == ""
          ? (this.contact.line_id = null)
          : (this.contact.line_id = this.contact.line_id);
        this.contact.line_link == ""
          ? (this.contact.line_link = null)
          : (this.contact.line_link = this.contact.line_link);
        this.contact.facebook == ""
          ? (this.contact.facebook = null)
          : (this.contact.facebook = this.contact.facebook);
        this.contact.facebook_link == ""
          ? (this.contact.facebook_link = null)
          : (this.contact.facebook_link = this.contact.facebook_link);
        this.contact.after_sales_contact == ""
          ? (this.contact.after_sales_contact = null)
          : (this.contact.after_sales_contact = this.contact.after_sales_contact);
        let data = this.contact;
        data.update_by = this.profile.staff_id;
        // console.log(data);
        this.axios
          .put(
            process.env.VUE_APP_API + "/api/v1/complain",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data.result);
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.btn_loading = false;
              this.$swal.fire({
                icon: "success",
                width: 500,
                title: response.data.message,
                text: "ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              setTimeout(() => {
                // this.$refs.form.reset();
                this.$refs.form.resetValidation();
              }, 50);
              this.mode = false;
              this.getData();
            } else {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: response.data.message,
                text: " กรุณาตรวจสอบข้อมูลของท่านอีกครั้ง",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          });
      } else {
        this.$swal.fire({
          icon: "warning",
          title: "กรุณาตรวจสอบข้อมูล",
          text: "หากไม่มีข้อมูลกรุณา '-'",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
  },
};
</script>

